import { Component, type ComponentChildren } from 'preact';
import { t } from '../lib/i18n.js';

interface State {
  error: Error | null;
}

/** Keeps one broken screen or sheet from taking the whole app down. */
export class ErrorBoundary extends Component<{ children: ComponentChildren }, State> {
  override state: State = { error: null };

  static override getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error): void {
    console.error(error);
  }

  override render() {
    if (this.state.error) {
      return (
        <div class="banner">
          {t('errorScreen')}: {this.state.error.message}.{' '}
          <button type="button" class="btn btn-ghost" onClick={() => location.reload()}>
            {t('reload')}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
